export const BlockPanelHeaderParams = ["Hash", "Height", "Size", "Timestamp"];
export const BlockPanelBodyParams = [
  {
    Hash: "0",
    Size: "2",
    Height: "50591842",
    Timestamp: "12/05/2023, 02:55:43",
    Proposer: "0x21C3de23d98Caddc406E3d31b25e807aDDF33633",
  },
  {
    Hash: "1",
    Size: "2",
    Height: "50591843",
    Timestamp: "12/05/2023, 02:55:43",
    Proposer: "0x21C3de23d98Caddc406E3d31b25e807aDDF33634",
  },
  {
    Hash: "2",
    Size: "2",
    Height: "50591844",
    Timestamp: "12/05/2023, 02:55:43",
    Proposer: "0x21C3de23d98Caddc406E3d31b25e807aDDF33635",
  },
  {
    Hash: "3",
    Size: "2",
    Height: "50591845",
    Timestamp: "12/05/2023, 02:55:43",
    Proposer: "0x21C3de23d98Caddc406E3d31b25e807aDDF33636",
  },
  {
    Hash: "4",
    Size: "2",
    Height: "50591846",
    Timestamp: "12/05/2023, 02:55:43",
    Proposer: "0x21C3de23d98Caddc406E3d31b25e807aDDF33637",
  },
  {
    Hash: "5",
    Size: "2",
    Height: "50591847",
    Timestamp: "12/05/2023, 02:55:43",
    Proposer: "0x21C3de23d98Caddc406E3d31b25e807aDDF33638",
  },
  {
    Hash: "6",
    Size: "2",
    Height: "50591848",
    Timestamp: "12/05/2023, 02:55:43",
    Proposer: "0x21C3de23d98Caddc406E3d31b25e807aDDF33639",
  },
  {
    Hash: "6",
    Size: "2",
    Height: "50591849",
    Timestamp: "12/05/2023, 02:55:43",
    Proposer: "0x21C3de23d98Caddc406E3d31b25e807aDDF33640",
  },
  {
    Hash: "6",
    Size: "2",
    Height: "50591850",
    Timestamp: "12/05/2023, 02:55:43",
    Proposer: "0x21C3de23d98Caddc406E3d31b25e807aDDF33641",
  },
  {
    Hash: "6",
    Size: "2",
    Height: "50591851",
    Timestamp: "12/05/2023, 02:55:43",
    Proposer: "0x21C3de23d98Caddc406E3d31b25e807aDDF33642",
  },
  {
    Hash: "6",
    Size: "2",
    Height: "50591852",
    Timestamp: "12/05/2023, 02:55:43",
    Proposer: "0x21C3de23d98Caddc406E3d31b25e807aDDF33643",
  },
];
